import { render } from "./ContainerAttributesInput.vue?vue&type=template&id=49e538f1"
import script from "./ContainerAttributesInput.vue?vue&type=script&lang=js"
export * from "./ContainerAttributesInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__